import { NumberHelper } from './number-helper';

export namespace LiveHelper {
	export const LIVE_EDGE_MIN_OFFSET = 5;
	export const LIVE_POSITION_OFFSET = -3;
	export const LIVE_MIN_DVR_WINDOW = 120;

	export const LIVE_STREAM_TYPE_ON_DEMAND = 'Od';
	export const LIVE_STREAM_TYPE_LIVE = 'Live';
	export const LIVE_STREAM_TYPE_DVR = 'Dvr';

	export const getLivePosition = (currentPosition: number, duration: number): number => {
		const start = 0;
		const end = duration;
		return NumberHelper.precision3(currentPosition > start ? (currentPosition < end ? currentPosition : end) : start);
	};

	export const isAtLive = (isMediaLive: boolean, currentPosition: number | '', duration: number): boolean => {
		if (!isMediaLive) {
			return false;
		}

		if (typeof currentPosition === "string" || Math.abs(duration) <= LIVE_MIN_DVR_WINDOW) {
			return true;
		}

		if (getStreamType(isMediaLive, duration) === LIVE_STREAM_TYPE_LIVE) {
			return true;
		}

		const currentPos = typeof currentPosition === "string" ? 0 : currentPosition;
		return Math.abs(duration - currentPos) <= LIVE_EDGE_MIN_OFFSET * 2;
	};

	export const getStreamType = (isMediaLive: boolean, duration: number) => {
		//KK-1346 - NOTE
		// Using the same logic as Gobrain. If a Media is live and their DRV window is < min window -> hidden seekm forward/backward feature.
		//Preference: qbrick-player/video-js-7.js/line 84
		return !isMediaLive ? LIVE_STREAM_TYPE_ON_DEMAND : duration && LIVE_MIN_DVR_WINDOW <= duration ? LIVE_STREAM_TYPE_DVR : LIVE_STREAM_TYPE_LIVE;
	};
}
